import React from "react";
import { motion } from "framer-motion";
import { spring } from "../theme/motion";

const sizes = { sm: 28, md: 32, lg: 40 };

export default function IconButton({ size = "md", children, "aria-label": ariaLabel, ...rest }) {
  const px = sizes[size];
  return (
    <motion.button
      whileTap={{ scale: 0.92 }}
      whileHover={{ y: -1 }}
      transition={spring.quick}
      aria-label={ariaLabel}
      style={{ width: px, height: px, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: 8, color: "var(--color-text-secondary)", background: "transparent", border: "none", cursor: "pointer" }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "var(--color-bg-muted)"; e.currentTarget.style.color = "var(--color-text-primary)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--color-text-secondary)"; }}
      {...rest}
    >
      {children}
    </motion.button>
  );
}
